import { Narrow } from 'component/basics';
import { colorTextPrimary } from 'component/color';
import { AutoModeratorReactionTypesWidget } from 'open-modules/zdf/component/conversationhelper/autoModeratorReactions';
import {
    ConversationHelperAdminScreen,
    ThoughtProvokingPrompt,
    ThoughtProvokingPromptHistory,
    ThoughtProvokingPromptHistoryItem,
} from 'open-modules/zdf/feature/conversation-helper';
import { View } from 'react-native';
import { DemoSection } from 'system/demo';
import { Datastore } from 'util/datastore';
import { StructureDemo } from 'util/instance';

import { conversationHelperDemoData } from './conversationhelperdemo.data';

export function ThoughtProvokingPromptDemo() {
    const collections = {
        thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
        thought_provoking_prompt_reactions: conversationHelperDemoData.reactions,
        summary: conversationHelperDemoData.summaries,
    };
    const config = {
        conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes,
    };

    return (
        <Narrow>
            <View style={{ gap: 12 }}>
                <DemoSection text='Thought-Provoking Prompt'>
                    <Datastore config testState={{ collections }}>
                        <ThoughtProvokingPrompt currentThoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[2]} />
                    </Datastore>
                </DemoSection>

                <DemoSection text='Thought-Provoking Prompt with Reactions'>
                    <Datastore config={{ ...config, reactionsEnabled: true }} testState={{ collections }}>
                        <ThoughtProvokingPrompt currentThoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[2]} />
                    </Datastore>
                </DemoSection>

                <DemoSection text='Thought-Provoking Prompt with History'>
                    <Datastore config={{ ...config, historyEnabled: true }} testState={{ collections }}>
                        <ThoughtProvokingPrompt currentThoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[2]} />
                    </Datastore>
                </DemoSection>

                <DemoSection text='Thought-Provoking Prompt with Summary'>
                    <Datastore config={{ ...config, summaryEnabled: true }} testState={{ collections }}>
                        <ThoughtProvokingPrompt currentThoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[2]} />
                    </Datastore>
                </DemoSection>

                <Datastore config={{ ...config, summaryEnabled: true }} testState={{ collections }}>
                    <DemoSection text='Thought-Provoking Prompt History'>
                        <ThoughtProvokingPromptHistory />
                    </DemoSection>
                    <DemoSection text='Thought-Provoking Prompt History Item'>
                        <ThoughtProvokingPromptHistoryItem thoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[0]} />
                    </DemoSection>
                </Datastore>

                <Datastore config={{ ...config, summaryEnabled: true, reactionsEnabled: true }} testState={{ collections }}>
                    <DemoSection text='Thought-Provoking Prompt History Item with Reactions'>
                        <ThoughtProvokingPromptHistoryItem thoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[0]} />
                    </DemoSection>
                </Datastore>

                <Datastore config={{ ...config, summaryEnabled: true }} testState={{ collections }}>
                    <DemoSection text='Thought-Provoking Prompt Reaction Widget - Newest Prompt'>
                        <AutoModeratorReactionTypesWidget thoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[2]} />
                    </DemoSection>
                    <DemoSection text='Thought-Provoking Prompt Reaction Widget - Previous Prompt'>
                        <AutoModeratorReactionTypesWidget thoughtProvokingPrompt={conversationHelperDemoData.thoughtProvokingPrompts[0]} />
                    </DemoSection>
                </Datastore>
            </View>
        </Narrow>
    );
}

export function ThoughtProvokingPromptAdminDemo() {
    return (
        <View>
            <Datastore
                config={{
                    reactionTypes: conversationHelperDemoData.reactionTypes,
                    conversationHelperTextColor: colorTextPrimary,
                }}
                testState={{
                    globals: conversationHelperDemoData.globals,
                    roles: ['Moderator'],
                    collections: {
                        thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
                        thought_provoking_prompt_reactions: conversationHelperDemoData.reactions,
                        comment: conversationHelperDemoData.comments,
                    },
                    serverCall: conversationHelperDemoData.serverCalls,
                }}
            >
                <ConversationHelperAdminScreen></ConversationHelperAdminScreen>
            </Datastore>
        </View>
    );
}

export function ConversationHelperFullDemo() {
    const collections = {
        comment: conversationHelperDemoData.comments,
        thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
    };
    return (
        <StructureDemo
            features={{ conversationhelper: true }}
            structureKey='question'
            testState={{
                roles: ['Moderator'],
                collections,
                globals: conversationHelperDemoData.globals,
                serverCall: conversationHelperDemoData.serverCalls,
            }}
        />
    );
}

export function ConversationHelperAdminFullDemo() {
    const collections = {
        comment: conversationHelperDemoData.comments,
        thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
    };
    return (
        <StructureDemo
            features={{ conversationhelper: true }}
            screenKey={'convohelperadmin'}
            structureKey='question'
            testState={{ globals: conversationHelperDemoData.globals, collections }}
        />
    );
}
